import { render, staticRenderFns } from "./SectionTitleAdditional.vue?vue&type=template&id=6658a7fe&"
import script from "./SectionTitleAdditional.vue?vue&type=script&lang=ts&"
export * from "./SectionTitleAdditional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports